import * as React from 'react'
import { Image } from '@shared/components/image'
import { ExternalPaths } from '@shared/menu-items/paths'

import styles from './style.module.scss'

const View = () => {
	return (
		<div className={styles.disclaimer}>
			<div className={styles.col}>
				<div className={styles.images}>
					<a href={ExternalPaths.skolkovo} target='_blank' rel='noopener noreferrer nofollow'>
						<Image name='new-skolkovo.png' className={styles.img} />
					</a>
				</div>
				<p>
					ООО «Кредит.Клаб» — участник инновационного центра «Сколково». Мы предоставляем цифровой
					сервис для удобного получения кредитов (
					<a
						href='https://creditclub.tech/'
						target='_blank'
						className={styles.details}
						rel='noopener noreferrer nofollow'
					>
						более подробно
					</a>
					).
				</p>
			</div>
			<p>
				Кредитором по кредитному договору будет являться кредитная организация-партнёр, принявшая
				решение о выдаче кредита. Сервис цифровых решений не является деятельностью оператора
				инвестиционной платформы по содействию в инвестировании и в предоставлении займов с
				использованием инвестиционной платформы.
			</p>
		</div>
	)
}

export default View
